


import { Injectable } from '@angular/core';

import { HttpClient ,HttpHeaders} from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { DataService } from '../../../services/data.service';
import { BusinessSubcriptionRequest } from '../../../POS/models/business-subcription-request';
import { CommonFunctionService, UserMerchantData, UserPOSData} from '../../../services/Common/common-function.service';
import { catchError, map } from 'rxjs';


@Injectable()
export class BusinessInfoService {
  userId: any;
  token;
  headers: any;
  constructor(private service: DataService, private http: HttpClient,private common:CommonFunctionService) {
    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid();
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
  }

  // GetBusinessInfo(data) {
  //   return this.service
  //     // .getAll(environment.GetBusinessInfoUrl + "?PosSubscriptionId=" + data)
  //     // .map(response => response);
  //     .getAll(environment.GetBusinessInfoUrl + "?PosSubscriptionId=" + data.PosSubscriptionId)
  //     .map(response => response);
  // }
  GetBusinessInfo(data) {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.GetBusinessInfoUrl + "?PosSubscriptionId=" + data.PosSubscriptionId,{headers:this.headers})
    .pipe(map(response => response)) ;
  }

  AddBusinessUrl(data)
  {
    this.GetGeaderdetails();
    // return this.service.create(environment.AddBusinessUrl, data);
    return this.http.post<BusinessSubcriptionRequest>(environment.AddBusinessUrl, data,{headers:this.headers});
  }
  InsertPayGPaymentGatewaySetups(data)
  {
    this.GetGeaderdetails();
    return this.http.post(environment.InsertPayGPaymentGatewaySetups, data,{headers:this.headers});
  }

  UpdateBusinessinfo(data)
  {
    this.GetGeaderdetails();
    return this.http.post<any>(environment.UpdateBusinessinfoUrl, data,{headers:this.headers});
    // return this.service.create(environment.UpdateBusinessinfoUrl, data);
  }
  GetBusinessHoursList(data) {
    this.GetGeaderdetails();
    return this.http
      .get(environment.GetBusinessHoursListUrl + "?PosSubscriptionId=" + data,{headers:this.headers})
      .pipe(map(response => response)) ;
  }

  GetBusinessHoursDetail(data) {
    this.GetGeaderdetails();
    return this.http
      .get(environment.GetBusinessHoursDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id,{headers:this.headers})
      .pipe(map(response => response));
  }

  AddBusinessHours(data)
  {
    this.GetGeaderdetails();
    return this.http.post(environment.AddBusinessHoursUrl, data,{headers:this.headers});
  }

  UpdateBusinessHours(data) {
    this.GetGeaderdetails();
    // return this.service.put(
    //   environment.UpdateBusinessHoursUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.Id,data );
    return this.http.post(
      environment.UpdateBusinessHoursUrl ,data ,{headers:this.headers});
  }


  InsertBusinessLogo(PosSubscriptionId,data,Flag) {
    this.GetGeaderdetails();
    return this.http.post(environment.BusinesslogoUploadUrl + "?PosSubscriptionId=" + PosSubscriptionId + "&Flag=" + Flag,data,{headers:this.headers})  
    .pipe(map(response => response))    
    .pipe(catchError(this.common.handleError));
  }
  
  
  GetDomainurl(data,Id)
  {
    this.GetGeaderdetails();
    return this.http.get(environment.DomainUrl + "?Id=" + data+ "&PosSubscriptionId=" + Id,{headers:this.headers})  
  .pipe(map(response => response))
  .pipe(catchError(this.common.handleError));
  }



  GetTaxfeedetails(data)
  {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.GetTaxesFeeList + "?PosSubscriptionId=" + data,{headers:this.headers})
    .pipe(map(response => response))  
  }
  GetCategorydetails(data)
  {
    //this.GetGeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+ ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
    return this.http.get<any>(environment.GetItemCategoryList + "?PosSubscriptionId=" + data,{headers:this.headers})
    .pipe(map(response => response))  
  }
  GetItemdetails(data)
  {
    // this.GetGeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();

    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+ ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));

    return this.http.get<any>(environment.GetItemList + "?PosSubscriptionId=" + data,{headers:this.headers})
    .pipe(map(response => response))  
  }
  Getorderdetails(data)
  {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.GetordermanagementListUrl + "?PosSubscriptionId=" + data,{headers:this.headers})
    .pipe(map(response => response))  
  }
  GetgetBusinessInfo(data) {
    this.GetGeaderdetails();
    return this.http.get<BusinessSubcriptionRequest>(environment.GetBusinessInfoUrl + "?PosSubscriptionId=" + data,{headers:this.headers})
    .pipe(map(response => response))  
  }

  GetItemListUrl(posId)
  {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.GetItemListUrl + "?PosSubscriptionId=" + posId,{headers:this.headers})
    .pipe(map(response => response))  ;
  }
  Zipcodedetails(Zipcode)
  {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.Zipcodedetailsurl+"?Zipcode=" + Zipcode,{headers:this.headers})  
    .pipe(map(response => response))    
    .pipe(catchError(this.common.handleError));
  }


  GetGeaderdetails()
  {
    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid();
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));

  }
}
